import * as yup from "yup";

export const TitleSchema = yup.string().required()
export const DescriptionSchema = yup.string()
export const WeightSchema = yup.number().positive().integer().min(0).max(100).optional()
export const QuestionIdsSchema = yup.array().of(yup.string()).optional()
export const ExamplesSchema = yup.array().of(yup.object()).optional()

export const AttributeSchema = yup.object().shape({
  title: TitleSchema,
  description: DescriptionSchema,
  weight: WeightSchema,
  questionIds: QuestionIdsSchema,
  examples: ExamplesSchema,
})

export const ValueSchema = yup.object().shape({
    title: TitleSchema,
    description: DescriptionSchema.required(),
    weight: WeightSchema,
    attributes: yup.array().of(AttributeSchema).required(),
})

export const ValueMetaDataSchema = yup.object().shape({
    title: TitleSchema,
    description: DescriptionSchema.required(),
    weight: WeightSchema
});